import { is } from '@common/is/is'

import type { TRelation, TRestrictionSplittedVersion } from '../definitions'

/**
 * Kitiltjuk a Version szerint?
 * @param version           - Splittelt verziószám.
 * @param restrictedVersion - Splittelt verziószám.
 * @param sign              - Relációs jel.
 */
export default function isRestrictedBySplittedVersions (
  version: TRestrictionSplittedVersion,
  restrictedVersion: TRestrictionSplittedVersion,
  sign: TRelation
): boolean {
  if (sign === '=') {
    return version.every((num, i) => num === restrictedVersion[i])
  }

  const actNum = version.shift()
  const actRestrictedNum = restrictedVersion.shift()

  if (is.number(actNum) && is.number(actRestrictedNum)) {
    if (actNum === actRestrictedNum) {
      return isRestrictedBySplittedVersions(version, restrictedVersion, sign)
    }

    if (sign === '<') {
      return actNum < actRestrictedNum
    }

    return actNum > actRestrictedNum
  }

  return false
}
